// extracted by mini-css-extract-plugin
var _1 = "date-from-to_separator__oElk2";
export { _1 as "separator" }
